$(document).ready(function () {

  $('[href="#"]').attr("href", "javascript:;");

  
// Tabbing JS
$('[data-targetit]').on('click', function(e) {
  $(this).addClass('current');
  $(this).siblings().removeClass('current');
  var target = $(this).data('targetit');
  $('.' + target).siblings('[class^="boxTabs-"]').hide();
  $('.' + target).fadeIn();
  $(".tab-slider").slick("setPosition");
});



  $('.collection-sidebar')
  .parent()
  .parent()
  .siblings()
  .find('.image-wrap')
  .each(function () {
    this.style.setProperty('min-height', '250px', 'important');
  });





});